export const locationReducerSelector = state => state.locationReducer;
